import { render } from "./owner-details.vue?vue&type=template&id=e6feb1dc"
import script from "./owner-details.vue?vue&type=script&lang=js"
export * from "./owner-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__